import { formatOperatingCurrency } from "./money";

export function formatCurrency(n) {
  return formatOperatingCurrency(n);
}

export function formatRelative(iso, locale = "en-NG") {
  if (!iso) return "—";
  const d = new Date(iso);
	if (!Number.isFinite(d.getTime())) return "—";
  const elapsedSeconds = (Date.now() - d.getTime()) / 1000;
	if (!Number.isFinite(elapsedSeconds)) return "—";
  const formatter = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  if (elapsedSeconds < 60) return formatter.format(0, "second");
  if (elapsedSeconds < 3600) return formatter.format(-Math.floor(elapsedSeconds / 60), "minute");
  if (elapsedSeconds < 86400) return formatter.format(-Math.floor(elapsedSeconds / 3600), "hour");
  if (elapsedSeconds < 7 * 86400) return formatter.format(-Math.floor(elapsedSeconds / 86400), "day");
  return d.toLocaleDateString(locale, { day: "2-digit", month: "short" });
}

export function formatDateTime(iso, locale = "en-NG") {
	if (!iso) return "—";
	const date = new Date(iso);
	if (!Number.isFinite(date.getTime())) return "—";
	return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }).format(date);
}

export function formatTime(iso, locale = "en-NG") {
  if (!iso) return "—";
	const date = new Date(iso);
	if (!Number.isFinite(date.getTime())) return "—";
	return date.toLocaleTimeString(locale, {
    hour: "numeric",
    minute: "2-digit",
  });
}

export function productStockStatus(product) {
  if (product.stock === null || product.stock === undefined) return "untracked";
  if (product.stock === 0) return "stock_out";
  if (product.stock <= product.lowStockAt) return "low_stock";
  return "in_stock";
}
